<!-- <div class="akit-header">
    <img src="./assets/algebrakit-logo.png">
</div> -->
<div class="page">
    <router-outlet></router-outlet>
</div>
